<app-breadcrumbs title="{{ id ? 'DOCUMENT_NUMBERING.EDIT_TITLE' : 'DOCUMENT_NUMBERING.CREATE_TITLE' }}" [first]="'MENU.ADMINISTRATION.DOCUMENT_NUMBERING'" [url]="'/document-numbering'" [id]="breadcrumbsId"></app-breadcrumbs>

<div class="btn-container">
    <dx-button *ngIf="((authorities.create && id == null) || (authorities.update && id != null))" class="ml-2 navbar-button" [height]="32" stylingMode="contained" icon="save" [disabled]="!pendingChanges" [text]="'SHARED.SAVE_CHANGES' | translate" type="success" (onClick)="saveChanges($event)"></dx-button>
</div>

<div class="row">
    
    <div class="col-12 col-xxl-4">
        <dx-form #form class="form-vertical" [formData]="formData" [showColonAfterLabel]="false" (onFieldDataChanged)="fieldDataChanged($event)">
            <dxi-item dataField="documentType" editorType="dxSelectBox" [editorOptions]="{ dataSource: documentTypes, valueExpr: 'value', displayExpr: 'label', searchEnabled: true, readOnly: !((authorities.create && id == null) || (authorities.update && id != null))}">
                <dxo-label location="left" alignment="left" [text]="'DOCUMENT_NUMBERING.DOCUMENT_TYPE' | translate"></dxo-label>
                <dxi-validation-rule type="required" [message]="'VALIDATION.REQUIRED' | translate"></dxi-validation-rule>
            </dxi-item>
            <dxi-item dataField="prefix" editorType="dxTextBox" [editorOptions]="{ valueChangeEvent: 'keyup', maxLength: 300, readOnly: !((authorities.create && id == null) || (authorities.update && id != null)), onValueChanged: codeToUpper() }">
                <dxo-label location="left" alignment="left" [text]="'DOCUMENT_NUMBERING.PREFIX' | translate"></dxo-label>
                <dxi-validation-rule type="required" [message]="'VALIDATION.REQUIRED' | translate"></dxi-validation-rule>
            </dxi-item>            
            <dxi-item dataField="usesYear" editorType="dxCheckBox" [editorOptions]="{ readOnly: !((authorities.create && id == null) || (authorities.update && id != null)), onValueChanged: constructPrefix() }">
                <dxo-label location="left" alignment="left" [text]="'DOCUMENT_NUMBERING.USES_YEAR' | translate"></dxo-label>
            </dxi-item>
        </dx-form>
        
    </div>
    <div class="col-12 col-xxl-8">
        <dx-tab-panel class="form-panel bg-second" [dataSource]="tabs" [selectedIndex]="0" [loop]="false" [animationEnabled]="true" [swipeEnabled]="true">
            <div *dxTemplate="let tab of 'title'">
                <span>{{'SHARED.' + tab | translate}}</span>
            </div>
                <div class="bg-second" *dxTemplate="let tab of 'item'">
                    <div *ngIf="tab == 'EXAMPLE'">                       
                        <h4 class="my-3 d-block text-center">{{ example }}</h4>
                    </div>
                </div>
        </dx-tab-panel>
    </div>  
</div>
